import { i18n } from "services/i18nService";
import { formatNameLinkField } from "services/utility/formatting";

export const columnInfo = [
  {
    name: "revoke",
    buttonLabel: i18n("columns.Revoke"),
    buttonAction: "revoke",
    isButton: true,
    fixed: true,
    excludeFromColumnList: true,
  },
  {
    name: "appName",
    fixed: true,
    heading: i18n("columns.Application"),
    formatFunc: formatNameLinkField,
    defaultSort: true,
    sortable: true,
  },
  {
    name: "authorizedUser",
    heading: i18n("columns.User"),
    sortable: true,
    fixedRightOfAction: true,
    fixed: true,
  },
  {
    name: "message",
    heading: i18n("columns.Message"),
    sortable: true,
    fixedRightOfAction: true,
    fixed: true,
  },
];

const columnArray = Object.entries(columnInfo);
const defaultColumnInfo = columnArray.filter((col) => col[1].required);
export const defaultColumns = defaultColumnInfo.map((col) => col[0]);

export const LINE_ACTIONS = [];
export const BATCH_ACTIONS = [];

export function getEmptyRecord() {
  return {
    name: null,
    description: null,
  };
}
